import { OS_STATUS_COLORS } from '@mustauto/brand';
import type { BadgeProps } from '@/components/ui/badge';

interface StatusConfig {
  label: string;
  variant: BadgeProps['variant'];
}

export const STATUS_MAP: Record<string, StatusConfig> = {
  in_analysis: { label: 'Em Análise', variant: 'info' },
  in_execution: { label: 'Em Execução', variant: 'warning' },
  waiting_part: { label: 'Aguardando Peça', variant: 'secondary' },
  outsourced: { label: 'Terceirizado', variant: 'secondary' },
  completed: { label: 'Concluída', variant: 'success' },
  waiting_payment: { label: 'Ag. Pagamento', variant: 'warning' },
  cancelled: { label: 'Cancelada', variant: 'destructive' },
  delivered: { label: 'Entregue', variant: 'success' },
};

/**
 * Cores das séries por status, vindas de `@mustauto/brand`.
 *
 * Antes este mapa divergia do resto do produto: pintava "aguardando peça" de
 * violeta (que é a cor de "terceirizado") e "aguardando pagamento" de laranja
 * (que é "em execução"). O mesmo status tinha cor diferente conforme a tela.
 */
export const CHART_COLORS: Record<string, string> = Object.fromEntries(
  Object.entries(OS_STATUS_COLORS).map(([status, c]) => [status, c.base]),
);
